var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"type":"bar","height":_vm.height,"width":"100%","options":_vm.options,"series":_vm.datasource}})
}
var staticRenderFns = []

export { render, staticRenderFns }